import loadable from "@loadable/component";
import React from "react";
import { PageBuilderCollectionSliderFragment } from "types/graphql-types";
import PageBuilderSectionTitle from "./PageBuilderSectionTitle";
import { ComponentBackgroundColor } from "types/componentBackground";
import { WindowLocation } from "@reach/router";
import { graphql } from "gatsby";

const DestinationsSlider = loadable(
  () => import("../CollectionSlider/DestinationsSlider")
);
const ShipsSlider = loadable(() => import("../CollectionSlider/ShipsSlider"));
const OffersSlider = loadable(() => import("../CollectionSlider/OffersSlider"));

interface PageBuilderCollectionSliderProps
  extends PageBuilderCollectionSliderFragment {
  cardBackgroundColor?: ComponentBackgroundColor;
  location: WindowLocation;
}

const PageBuilderCollectionSlider: React.FC<PageBuilderCollectionSliderProps> = ({
  heading,
  collection,
  cardBackgroundColor,
  showExpeditionsOnly = false,
  location
}) => {
  return (
    <React.Fragment>
      <PageBuilderSectionTitle {...heading} />
      {collection == "destinations" && (
        <DestinationsSlider
          cardBackgroundColor={cardBackgroundColor}
          showExpeditionsOnly={showExpeditionsOnly || false}
        />
      )}
      {collection == "ships" && (
        <ShipsSlider
          cardBackgroundColor={cardBackgroundColor}
          showExpeditionsOnly={showExpeditionsOnly || false}
        />
      )}
      {collection == "offers" && (
        <OffersSlider
          cardBackgroundColor={cardBackgroundColor}
          location={location}
        />
      )}
    </React.Fragment>
  );
};

export default PageBuilderCollectionSlider;

export const fragments = graphql`
  fragment PageBuilderCollectionSlider on SanityCollectionSlider {
    _key
    heading {
      ...SectionTitle
      ...SectionTitleCTAs
    }
    collection
    showExpeditionsOnly
  }
`;
